import { Component } from '@angular/core';
import { BaseMenuItemComponent } from '../../base/base-menu-item.component';

@Component({
  selector: 'lbt-mobile-menu-item',
  standalone: false,
  templateUrl: './mobile-menu-item.component.html',
  styleUrl: './mobile-menu-item.component.scss',
})
export class MobileMenuItemComponent extends BaseMenuItemComponent{
}
